import { ReactComponent as Icon } from "../images/pdf.svg";

const PdfIcon  = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default PdfIcon;
